import React, { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

interface GuestGuardProps {
  children: ReactNode;
}

const GuestGuard: React.FC<GuestGuardProps> = ({ children }) => {
  const navigate = useNavigate();
  const { isLoggedIn, companyId } = useAuth();


  useEffect(() => {
    if (isLoggedIn) {
      if (companyId === 1) {
        navigate('/companies', { replace: true });
      } else {
        navigate('/dashboard', { replace: true });
      } // Redirect logged-in users to the dashboard
    }
  }, [isLoggedIn, navigate]);

  if (isLoggedIn) return null; // Prevent rendering guest-only content before redirection

  return <>{children}</>;  // If user is not authenticated, show the child components (login/signup page)

};

export default GuestGuard;
